import * as S from './PreQueueDeletedItemsTable.styles'
import { useSelector } from 'react-redux'
import { State } from 'src/features/types'
import TableMui from 'src/components/TableMui'
import { Typography } from '@mui/material'
import { formatDateUTC } from 'src/utils/formatDate'
import { useMemo } from 'react'

export const PreQueueDeletedItemsTable = () => {
  const supplierState = useSelector((state: State) => state.supplier)

  const resolveTableRows = useMemo(() => supplierState?.preQueueDeletedItems?.map((item) => {
    const resolveInvoices = () => item.invoices.map((invoice, index) => <div key={index}>{invoice.invoiceKey} -  { invoice.arStatus ? invoice.arStatus.replace('_', ' ') : 'SEM STATUS' }</div>)

    return {
      supplier: item.supplier?.nmFornecedor || item.supplierName,
      inputDate: formatDateUTC(item.createdAt),
      outputDate: formatDateUTC(item.deletedAt),
      status: resolveInvoices(),
    }
  }), [supplierState?.preQueueDeletedItems])

  return (
    <S.Wrapper>
      <Typography variant='h6' fontWeight='bold'>Histórico</Typography>
      <TableMui
        columns={[
          { id: 'supplier', label: 'Fornecedor' },
          { id: 'inputDate', label: 'Horário Chegada' },
          { id: 'outputDate', label: 'Horário Saída Pré-Fila' },
          { id: 'status', label: 'Status Notas' },
        ]}
        emptyLabel='Nenhum recebimento liberado nas últimas 24 horas.'
        rows={resolveTableRows}
        rowCount={resolveTableRows.length}
        enablePagination
        rowsPerPageLimit={10}
        rowsPerPageOptions={[5, 10, 25, 30, 50, 100, 200]}
        maxHeight='59vh'
        testId='pre-queue-deleted-items-table-test-id'
      />
    </S.Wrapper>
  )
}
